// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc2a1699","308":"ad51f0b0","578":"172c8243","977":"aaa02785"}[chunkId] + ".chunk.js";
};